import { render, staticRenderFns } from "./IconFlagOutline.vue?vue&type=template&id=66aecec2"
import script from "./IconFlagOutline.vue?vue&type=script&lang=js"
export * from "./IconFlagOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports